/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('itemCtrl', itemCtrl)
        .controller('newEditItemCtrl', newEditItemCtrl)
        .controller('deleteItemCtrl', deleteItemCtrl);


    itemCtrl.$inject = ['linkService', 'tabs','items','fareItems'];

    newEditItemCtrl.$inject = ['tabs', 'itemService', 'linkService', 'subClassificationService','item','action',
        'classifications','fareItems'];

    deleteItemCtrl.$inject = ['item', 'itemService', '$uibModalInstance', 'linkService'];

    function itemCtrl(linkService, tabs, items, fareItems){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.pages = items.data.page;
        vm.items = (items.data._embedded) ? items.data._embedded.items : [];


        vm.fareItems = (fareItems.data._embedded) ? fareItems.data._embedded.fareItems : [];
        vm.linkService = linkService;

        angular.forEach(vm.items, function(item){
            angular.forEach(vm.fareItems, function(fareItem){
                if(vm.linkService.getLinkId(fareItem._embedded.item._links.self.href)==
                    vm.linkService.getLinkId(item._links.self.href)){
                    item.fareItem = fareItem;
                }
            })
        });
    }

    function newEditItemCtrl(tabs, itemService, linkService, subClassificationService, item, action,classifications,
                             fareItems){
        var vm = this;
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.item = {
            rbcFareItem: {
                percentage: 0,
                fixedAmount: 0,
                baseTariff: true,
                itemId: 0
            }
        };
        vm.classifications = (classifications.data._embedded) ? classifications.data._embedded.classifications : [];

        vm.getSubClassifications = function (classificationId){
            if(classificationId != undefined){
                subClassificationService.getSubClassificationsByClassificationId(classificationId)
                    .then(function(response){
                        vm.subClassifications = (response.data._embedded) ? response.data._embedded.subClassifications : [];
                    });
            }else{
                vm.subClassifications = [];
            }
        }

        if(action == 'edit'){
            vm.item.description = item.data.description;
            vm.item.unitWeight = item.data.unitWeight;
            vm.item.unitHeight = item.data.unitHeight;
            vm.item.unitWidth = item.data.unitWidth;
            vm.item.lenght = item.data.length;
            vm.item.classificationId = vm.linkService.getLinkId(item.data._embedded.classification._links.self.href);
            vm.getSubClassifications(vm.item.classificationId);
            vm.item.subClassificationId = vm.linkService.getLinkId(item.data._embedded.subClassification._links.self.href);
            vm.item.itemId = vm.linkService.getLinkId(item.data._links.self.href);

            if(fareItems.data._embedded){
                vm.item.rbcFareItem.percentage = fareItems.data._embedded.fareItems[0].percentage;
                vm.item.rbcFareItem.fixedAmount = fareItems.data._embedded.fareItems[0].fixedAmount;
                vm.item.rbcFareItem.baseTariff = fareItems.data._embedded.fareItems[0].baseTariff;
            }
        }

        vm.saveItem = function(isValid, item){
            if (isValid) {
                if (item.rbcFareItem.percentage === 0) {
                    item.rbcFareItem.baseTariff =  false;
                    vm.item.rbcFareItem.baseTariff = false;
                } else if (item.rbcFareItem.percentage !== 0) {
                    item.rbcFareItem.baseTariff =  true;
                    vm.item.rbcFareItem.baseTariff = true;
                }
                if(action === "new"){
                    itemService.saveItem(item);
                }else{
                    itemService.updateItem(vm.item.itemId, vm.item)
                }
            }
        }
    }

    function deleteItemCtrl(item, itemService, $uibModalInstance, linkService){
        var vm = this;
        vm.item = item.data;

        vm.deleteItem = function(){
            itemService.deleteItem(linkService.getLinkId(item.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
